import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ItemContextService {
  private _item = new BehaviorSubject<any>(null);
  readonly item$ = this._item.asObservable();

  setItem(item: any): void {
    this._item.next(item);
  }

  get item(): any {
    return this._item.value;
  }
}
